import React, { ReactElement, useMemo, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import storage from 'helpers/storage';
import { useQuery } from 'react-query';

import { Container, ListTable, ListTablePanel, PageTitle, ServiceRadioGroup, ServiceRadioLabel } from './styles';
import { getCompanyServiceTypes, getClientContracts } from './state';
import { TClientContractLists, TServiceType } from './companyInfoTypes';

function CompanyInfo({ history }: RouteComponentProps): ReactElement {
  const comId = useMemo(() => {
    const company = storage.get('company');
    return company && company.id;
  }, []);
  const { data: serviceTypes } = useQuery<TServiceType[]>('getCompanyServiceTypes', () =>
    getCompanyServiceTypes(comId)
  );
  const { data: clientContractLists } = useQuery<TClientContractLists>('getClientContracts', () =>
    getClientContracts(comId)
  );

  const [serviceFilter, setServiceFilter] = useState<string>('ALL');

  const filteredContracts = useMemo(() => {
    const list = clientContractLists?.content ?? [];
    if (serviceFilter === 'ALL') return list;
    return list.filter((contract) => contract.contractType === serviceFilter);
  }, [serviceFilter, clientContractLists]);

  const goToDetail = (clientContractIdx?: number) => {
    if (clientContractIdx == null) return;
    history.push(`/service/management/company/info/${clientContractIdx}`);
  };

  return (
    <Container>
      <PageTitle>회사 정보</PageTitle>
      <ServiceRadioGroup role="radiogroup" aria-label="서비스 필터">
        <ServiceRadioLabel checked={serviceFilter === 'ALL'}>
          <input
            type="radio"
            name="serviceFilter"
            value="ALL"
            checked={serviceFilter === 'ALL'}
            onChange={() => setServiceFilter('ALL')}
          />
          전체
        </ServiceRadioLabel>
        {serviceTypes?.map((type) => {
          const value = type.contractType ?? '';
          const label = type.codeName ?? value;
          return (
            <ServiceRadioLabel key={value} checked={serviceFilter === value}>
              <input
                type="radio"
                name="serviceFilter"
                value={value}
                checked={serviceFilter === value}
                onChange={() => setServiceFilter(value)}
              />
              {label}
            </ServiceRadioLabel>
          );
        })}
      </ServiceRadioGroup>

      <ListTablePanel>
        <ListTable>
          <thead>
            <tr>
              <th>계약 번호</th>
              <th>상호명</th>
              <th>사업자 번호</th>
              <th>대표자 명</th>
              <th>서비스</th>
              <th>청구 범위</th>
              <th>세금계산서 수신 이메일 1</th>
              <th>세금계산서 수신 이메일 2</th>
              <th>입금계좌</th>
              <th>입금자 명</th>
            </tr>
          </thead>
          <tbody>
            {filteredContracts?.map((contract) => (
              <tr key={contract.clientContractIdx} onClick={() => goToDetail(contract.clientContractIdx)}>
                <td>{contract.clientContractIdx}</td>
                <td>{contract.bizName}</td>
                <td>{contract.bizNumber}</td>
                <td>{contract.bizPresidentName}</td>
                <td>{serviceTypes?.find((type) => type.contractType === contract.contractType)?.codeName ?? '-'}</td>
                <td>{contract.orgFullName}</td>
                <td>{contract.taxInvoiceEmail1 || '-'}</td>
                <td>{contract.taxInvoiceEmail2 || '-'}</td>
                <td>
                  {`${contract.vendysBankName ?? ''} ${contract.vendysAccountNumber ??
                    ''} (${contract.vendysBankAccountHolder ?? ''})`}
                </td>
                <td>{contract.depositAccountHolder}</td>
              </tr>
            ))}
          </tbody>
        </ListTable>
      </ListTablePanel>
    </Container>
  );
}

export default withRouter(CompanyInfo);
